import { useLayoutEffect, useState } from 'react';

export enum Breakpoint {
  mobile = 'mobile',
  tablet = 'tablet',
  desktop = 'desktop',
}

export const BREAKPOINT_DESKTOP = 1065;
export const BREAKPOINT_TABLET = 600;

function useBreakpoint() {
  const [breakpoint, setBreakpoint] = useState<Breakpoint>(
    window.innerWidth >= BREAKPOINT_DESKTOP ? Breakpoint.desktop : window.innerWidth > BREAKPOINT_TABLET ? Breakpoint.tablet : Breakpoint.mobile
  );

  useLayoutEffect(() => {
    function updateSize() {
      if (window.innerWidth >= BREAKPOINT_DESKTOP) {
        setBreakpoint(Breakpoint.desktop);
      } else if (window.innerWidth > BREAKPOINT_TABLET) {
        setBreakpoint(Breakpoint.tablet);
      } else {
        setBreakpoint(Breakpoint.mobile);
      }
    }

    window.addEventListener('resize', updateSize);
    updateSize();

    return () => window.removeEventListener('resize', updateSize);
  }, []);

  return breakpoint;
}

export const getViewportSize = () => {
  if (!window || innerWidth in window) return undefined;
  if (window.innerWidth >= 1065) {
    return Breakpoint.desktop;
  } else if (window.innerWidth > 600) {
    return Breakpoint.tablet;
  } else {
    return Breakpoint.mobile;
  }
};

export default useBreakpoint;
